import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pipeline-select-project-card',
  templateUrl: './select-project-card.component.html',
  styleUrls: ['./select-project-card.component.scss'],
})
export class SelectProjectCardComponent implements OnInit {

  constructor() { }
  
  
  

  ngOnInit() {}

}
